import React, { useEffect, useRef, useState } from "react";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import EventIcon from "@mui/icons-material/Event";

import {
  Box,
  Button,
  Divider,
  Fab,
  Grid,
  IconButton,
  InputAdornment,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import {
  getAccountReachageDetails,
  getAllEmpAttendance,
  getAllEmployeeList,
  getAlleducatio,
  saveEmployeeRecordForDay,
} from "./appoinmentDashboardApi";
import SmbAccountReachargeCard from "./AppoinmentDashboardCard";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";

import { getData } from "./smbAccountRechargeCustomApiHandler";

import {
  convertDateToCustomFormat,
  getFirstDateOfMonth,
  getStartOfMonth,
} from "../../utils/commonUtils";
import AppoinmentDashboardCard from "./AppoinmentDashboardCard";
import { DatePicker } from "@mui/x-date-pickers";
import DatePickerComponent from "../../common/curstomDatePicker";
import FormModal from "./FormModal";
import DynamicBreadcrumbs from "../../common/Breadcrumb";
import { useSelector } from "react-redux";
import { TextFieldSearch } from "../../common/fieldText";
import PoprchModal from "../payment/popSearch";
import CardPayment from "../payment/cardPayment";
import FormModalT from "./FormDatatt";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import present from "../../assets/present.png";
import halfday from "../../assets/halfday.png";
import absent from "../../assets/absent.png";
import EmployeeCalendar from "./employeeCalendar";
import calendar from "../../assets/icon/calendarblack.png";

export default function EmployeeAttendace({ gridSize }) {
  const [startDate, setStartDate] = useState(dayjs().format("YYYY-MM-DD"));

  useEffect(() => {
    const today = dayjs();
    setDate(today.format("DD-MM-YYYY"));
    setStartDate(today.format("YYYY-MM-DD"));
  }, []);
  // const [data, setData] = useState();
  const [open, setOpen] = useState(false);

  const [search, setSearchvalue] = useState("");
  const [searchModal, setSearchModal] = useState(false);

  const datePickerRef = useRef();

  const [date, setDate] = useState(getStartOfMonth());

  // useEffect(() => {
  //   getAllEmployeeList((res) => {
  //     setData(res?.list);
  //   });
  //   // getData(getAccountReachageDetails, setData);
  // }, []);
  const [selectedDate, setSelectedDate] = React.useState(null);
  const [isDatePickerOpen, setIsDatePickerOpen] = React.useState(false);
  const [cardValue, setCardValue] = useState(null);
  const [list, setList] = useState([]);
  const [calendarOpen, setCalendarOpen] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);

  // useEffect(() => {
  //   if (search?.id && startDate) {
  //     const payload = {
  //       employeeId: search.id,
  //       forDate: startDate,
  //     };

  //     getAllEmpAttendance(payload, (data) => {
  //       // console.log("Attendance Data: ", data);
  //       setList(data?.data?.data || []);
  //     });
  //   }
  // }, [search?.id, startDate]);
  useEffect(() => {
    if (search?.id && startDate) {
      const payload = {
        employeeId: search.id,
        forDate: startDate,
      };

      getAllEmpAttendance(payload, (data) => {
        console.log("Attendance Data:$$$$$$$$$$$$$ ", data);
        setList(data?.data?.data || []);
      });
    } else if (!search?.id && startDate) {
      const payload = {
        forDate: startDate,
      };

      getAllEmpAttendance(payload, (data) => {
        console.log("Attendance Data: @@@@@@@@@@@@@@", data);
        setList(data?.data?.data || []);
      });
    }
  }, [search?.id, startDate]);

  // useEffect(() => {
  //   getAllEmpAttendance(
  //     {
  //       // employeeId:search?.id
  //     },
  //     (data) => {
  //       // console.log("list  data?.data?.data ", data);
  //       console.log("Attendance Data: !!!!!!!!!!", data);

  //       setList(data?.data?.data);
  //     }
  //   );
  // }, []);

  useEffect(() => {
    if (open == false) {
      // setModalData({});
    }
  }, [open]);

  useEffect(() => {
    console.log("list list== ", list);
  }, [list]);
  //   const groupAttendanceByEmployee = (rawData = []) => {
  //     const grouped = {};

  //     rawData.forEach((entry) => {
  //       const empId = entry.employeeId;
  //       const date = dayjs(entry.forDate).format("YYYY-MM-DD");
  //       const status = entry.servedStatus?.toLowerCase(); // "present", "absent", "halfday"

  //       if (!grouped[empId]) {
  //         grouped[empId] = {
  //           employeeId: entry.employeeId,
  //           employeeName: entry.employeeName,
  //           empId: entry.empId,
  //           attendance: {},
  //         };
  //       }

  //       grouped[empId].attendance[date] = status;
  //     });

  //     return Object.values(grouped); // Convert object to array
  //   };
  // useEffect(() => {
  //   getAllEmpAttendance({ forDate: startDate }, (data) => {
  //     const rawList = data?.data?.data || [];
  //     const grouped = groupAttendanceByEmployee(rawList);
  //     setList(grouped); // Now each item in `list` has an `attendance` map
  //   });
  // }, [search?.id, startDate]);
  const handleAttendanceUpdate = (employee, status) => {
    setList((prevList) =>
      prevList.map((item) =>
        item.empId === employee.empId ? { ...item, servedStatus: status } : item
      )
    );

    const payload = {
      employeeId: Number(employee.empId),
      forDate: startDate,
      servedStatus: status,
    };

    saveEmployeeRecordForDay(payload, (res) => {
      if (res?.data?.success) {
        setList((prevList) =>
          prevList.map((item) =>
            item.empId === employee.empId
              ? { ...item, servedStatus: status }
              : item
          )
        );
      } else {
        console.error("Failed to update attendance", res);
        // Optionally revert optimistic update here
      }
    });
  };

  // useEffect(() => {
  //   getAllEmpAttendance();
  // }, []);
  return (
    <>
      <Box
        px={{ xs: 2, sm: 4 }}
        pb={4}
        container="true"
        sx={{
          paddingTop: "15px",
          backgroundColor: "#E3E3FF",
          fontFamily: "'Montserrat', sans-serif",
        }}
      >
        <Grid container>
          <Grid
            item
            xs={12}
            sx={{
              background:
                "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
              padding: "10px",
              borderRadius: "5px",
              color: "#01008B",
              textAlign: "left",
              marginBottom: "20px",
              fontSize: { xs: "12px", sm: "13px", md: "15px" },
              fontWeight: 500,
            }}
          >
            <Typography
              variant="h6"
              fontSize={{ xs: "12px", sm: "13px", md: "15px" }}
            >
              Employee Attendance
            </Typography>
          </Grid>
          <Grid container alignItems="center" spacing={2}>
            <Grid item xs={12} sm={6}>
              <Box
                sx={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  color: "#545454",
                }}
              >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    value={date ? dayjs(date, "DD-MM-YYYY") : null}
                    onChange={(newValue) => {
                      setDate(newValue.format("DD-MM-YYYY"));
                      setStartDate(newValue.format("YYYY-MM-DD"));
                    }}
                    format="DD-MM-YYYY"
                    error={!date}
                    slots={{ openPickerIcon: CalendarMonthIcon }}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        label: "Date",
                        size: "small",
                        InputProps: {
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton edge="end">
                                <Box
                                  component="img"
                                  src={calendar}
                                  alt="calendar icon"
                                  sx={{
                                    width: 20,
                                    height: 20,
                                    cursor: "pointer",
                                  }}
                                />
                              </IconButton>
                            </InputAdornment>
                          ),
                          sx: {
                            background: "#fff",
                            borderRadius: 1,
                            "& fieldset": { border: "none" },
                            "&:hover fieldset": { border: "none" },
                            "&.Mui-focused fieldset": { border: "none" },
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          },
                        },
                      },
                      openPickerIcon: {
                        sx: { color: "#000" },
                      },
                    }}
                  />
                </LocalizationProvider>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                value={search?.name || ""}
                placeholder="Employee Name"
                size="small"
                fullWidth
                variant="outlined"
                onClick={() => setSearchModal(true)}
                sx={{
                  width: "100%",
                  backgroundColor: "white",
                  borderRadius: "6px",
                  // color: "#555555",
                  "& .MuiOutlinedInput-root": {
                    border: "none",
                    "& fieldset": {
                      border: "none",
                    },
                    "&:hover fieldset": {
                      border: "none",
                    },
                    "&.Mui-focused fieldset": {
                      border: "none",
                    },
                  },
                  "& .MuiInputBase-input::placeholder": {
                    color: "#555555",
                    opacity: 6,
                    fontWeight: 500,
                    cursor: "pointer",
                  },
                }}
                InputLabelProps={{
                  className: "mulish",
                  sx: {
                    color: "#545454",
                    fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    paddingX: "7px",
                  },
                }}
                InputProps={{
                  sx: {
                    color: "#545454",
                    fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    paddingX: "7px",
                  },
                  readOnly: true,
                  endAdornment: (
                    <InputAdornment position="end">
                      {search?.name ? (
                        <CloseIcon
                          sx={{ cursor: "pointer" }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setSearchvalue("");
                            setCardValue(null);
                          }}
                        />
                      ) : (
                        <SearchIcon
                          color="primary"
                          sx={{ cursor: "pointer" }}
                        />
                      )}
                    </InputAdornment>
                  ),
                }}
              />

              <PoprchModal
                cardValue={cardValue}
                setCardValue={(data) => {
                  setSearchvalue(data);
                  setCardValue(data);
                }}
                callback={() => {}}
                searchModal={searchModal}
                setSearchModal={setSearchModal}
              />
            </Grid>
          </Grid>

          <Grid container spacing={{ sm: 8, xs: 3 }} alignItems="center" p={2}>
            {/* Present */}
            <Grid item>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Box
                  component="img"
                  src={present}
                  alt="Present"
                  sx={{ width: 24, height: 24 }}
                />
                <Typography
                  sx={{
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    fontWeight: 500,
                  }}
                >
                  Present
                </Typography>
              </Box>
            </Grid>

            {/* Half Day */}
            <Grid item>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Box
                  component="img"
                  src={halfday}
                  alt="Half Day"
                  sx={{ width: 24, height: 24 }}
                />
                <Typography
                  sx={{
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    fontWeight: 500,
                  }}
                >
                  Half Day
                </Typography>
              </Box>
            </Grid>

            {/* Absent */}
            <Grid item>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Box
                  component="img"
                  src={absent}
                  alt="Absent"
                  sx={{ width: 24, height: 24 }}
                />
                <Typography
                  sx={{
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    fontWeight: 500,
                  }}
                >
                  Absent
                </Typography>
              </Box>
            </Grid>
          </Grid>

          <Grid
            container
            sx={{
              p: "10px",
              // mt: 2,
              background: "white",
              borderRadius: "12px",
              overflowX: "auto",
            }}
          >
            {/* Header */}
            <Grid item xs={12}>
              <Grid
                container
                sx={{
                  borderBottom: "1.5px solid black",
                  padding: "10px",
                }}
              >
                <Grid item xs={3}>
                  <Typography
                    sx={{
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      textAlign: "center",
                      fontWeight: 500,
                      color: "#01008B",
                    }}
                  >
                    Employee Id
                  </Typography>
                </Grid>
                <Grid item xs={4} sm={3}>
                  <Typography
                    sx={{
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      textAlign: "center",
                      fontWeight: 500,
                      color: "#01008B",
                    }}
                  >
                    Employee Name
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            {/* Employee Rows */}
            <Grid
              item
              xs={12}
              sx={{
                height: "60vh",
                overflowY: "auto",
                marginTop: "10px",
                padding: "15px",
              }}
            >
              {list.map((ele, index) => {
                if (search && search?.name !== ele?.employeeName) return null;

                return (
                  <Grid
                    container
                    key={index}
                    onClick={() => {
                      setSelectedEmployee(ele);
                      setCalendarOpen(true);
                    }}
                    sx={{
                      p: "8px 0",
                      borderBottom: "1px solid #eee",
                      alignItems: "center",
                      backgroundColor: "#E8E8FF",
                      borderRadius: "8px",
                      mb: 1,
                      cursor: "pointer",
                    }}
                  >
                    {/* Employee Id */}
                    <Grid item xs={3}>
                      <Typography
                        sx={{
                          textAlign: "center",
                          fontWeight: "500",
                          fontSize: {
                            xs: "12px",
                            sm: "13px",
                            md: "15px",
                          },
                        }}
                      >
                        {ele?.employeeId || "-"}
                      </Typography>
                    </Grid>

                    {/* Employee Name */}
                    <Grid item xs={4} sm={3}>
                      <Typography
                        sx={{
                          textAlign: "left",
                          fontWeight: "500",
                          pl: { xs: 2, sm: 2, md: 4, lg: 10 },
                          fontSize: {
                            xs: "12px",
                            sm: "13px",
                            md: "15px",
                          },
                        }}
                      >
                        {ele?.employeeName || "-"}
                      </Typography>
                    </Grid>

                    {/* Attendance Icons */}
                    <Grid
                      item
                      xs={4}
                      sm={6}
                      sx={{
                        display: "flex",
                        justifyContent: "end",
                        gap: { xs: 1, sm: 4 },
                        paddingRight: { xs: "2px", sm: "60px" },
                      }}
                    >
                      {/* Present Icon */}
                      <Box
                        onClick={(e) => {
                          e.stopPropagation();
                          handleAttendanceUpdate(ele, "Present");
                        }}
                        sx={{
                          position: "relative",
                          width: 24,
                          height: 24,
                          borderRadius: "50%",
                          overflow: "hidden",
                          cursor: "pointer",
                          "&::after": {
                            content: '""',
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            borderRadius: "50%",
                            backgroundColor:
                              ele.servedStatus !== "Present"
                                ? "rgba(0, 0, 0, 0.5)"
                                : "transparent",
                            zIndex: 1,
                          },
                        }}
                      >
                        <Box
                          component="img"
                          src={present}
                          alt="Present"
                          sx={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            display: "block",
                            zIndex: 0,
                          }}
                        />
                      </Box>

                      {/* Half Day Icon */}
                      <Box
                        onClick={(e) => {
                          e.stopPropagation();
                          handleAttendanceUpdate(ele, "Half Day");
                        }}
                        sx={{
                          position: "relative",
                          width: 24,
                          height: 24,
                          borderRadius: "50%",
                          overflow: "hidden",
                          cursor: "pointer",
                          "&::after": {
                            content: '""',
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            borderRadius: "50%",
                            backgroundColor:
                              ele.servedStatus !== "Half Day"
                                ? "rgba(0, 0, 0, 0.5)"
                                : "transparent",
                            zIndex: 1,
                          },
                        }}
                      >
                        <Box
                          component="img"
                          src={halfday}
                          alt="Half Day"
                          sx={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            display: "block",
                            zIndex: 0,
                          }}
                        />
                      </Box>

                      {/* Absent Icon */}
                      <Box
                        onClick={(e) => {
                          e.stopPropagation();
                          handleAttendanceUpdate(ele, "Absent");
                        }}
                        sx={{
                          position: "relative",
                          width: 24,
                          height: 24,
                          borderRadius: "50%",
                          overflow: "hidden",
                          cursor: "pointer",
                          "&::after": {
                            content: '""',
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            borderRadius: "50%",
                            backgroundColor:
                              ele.servedStatus !== "Absent"
                                ? "rgba(0, 0, 0, 0.5)"
                                : "transparent",
                            zIndex: 1,
                          },
                        }}
                      >
                        <Box
                          component="img"
                          src={absent}
                          alt="Absent"
                          sx={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            display: "block",
                            zIndex: 0,
                          }}
                        />
                      </Box>
                    </Grid>
                  </Grid>
                );
              })}
            </Grid>
          </Grid>
        </Grid>
      </Box>

      <EmployeeCalendar
        open={calendarOpen}
        onClose={() => setCalendarOpen(false)}
        employee={selectedEmployee}
      />
    </>
  );
}
